// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoArea_container__XHmAb","imageContainer":"InfoArea_imageContainer__moQyU","decription":"InfoArea_decription__QGQR1"};